import {
  FETCH_FLAG_SUCCESS,
  FETCH_ALL_FLAGS_SUCCESS,
  SET_FLAG_SUCCESS,
  DESTROY_FLAG_SUCCESS,
  CREATE_FLAG_SUCCESS,
} from '../actions/featureFlags';
import { createReducer } from './utils';

const fetchFlagSuccess = (state, action) => ({
  ...state,
  [action.data.id]: action.data,
});

const createFlagSuccess = (state, action) => ({
  ...state,
  [action.data.id]: action.data
});

const fetchAllFlagsSuccess = (state, action) => ({
  ...state,
  ...action.data,
});

const setFlagSuccess = (state, action) => ({
  ...state,
  [action.data.id]: action.data,
});

const destroyFlagSuccess = (state, action) => {
  const newState = state;
  delete newState[action.id];
  return newState;
};

export default createReducer({}, {
  [FETCH_FLAG_SUCCESS]: fetchFlagSuccess,
  [FETCH_ALL_FLAGS_SUCCESS]: fetchAllFlagsSuccess,
  [SET_FLAG_SUCCESS]: setFlagSuccess,
  [DESTROY_FLAG_SUCCESS]: destroyFlagSuccess,
  [CREATE_FLAG_SUCCESS]: createFlagSuccess,
});
